import { success } from "toastr";
import {
  FETCH_ALLOWANCES,
  FETCH_ALLOWANCES_SUCCESS,
  FETCH_ALLOWANCES_FAILURE,
  CREATE_ALLOWANCE_REQUEST,
  CREATE_ALLOWANCE_SUCCESS,
  CREATE_ALLOWANCE_FAILURE,
  DELETE_ALLOWANCE,
  DELETE_ALLOWANCE_SUCCESS,
  DELETE_ALLOWANCE_FAILURE,
} from "./actionTypes";

const initialState = {
  allowances: [],
  loading: false,
  error: null,
  success:false
};

const payrollSetupAllowanceReducer = (state = initialState, action) => {
 
  switch (action.type) {
    case FETCH_ALLOWANCES:
      return { ...state, loading: true };
    case FETCH_ALLOWANCES_SUCCESS:
      return { ...state, loading: false, allowances: action.payload.data};
    case FETCH_ALLOWANCES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case CREATE_ALLOWANCE_REQUEST:
      return { ...state, loading: true, success:false, error: null };
    
    case CREATE_ALLOWANCE_SUCCESS:
      return { ...state, loading: false, success:true, allowanceData: action.payload, error: null };

    case CREATE_ALLOWANCE_FAILURE:
      return { ...state, loading: false, success:false, error: action.payload };

    case DELETE_ALLOWANCE:
      return { ...state, loading: true, success:false, error: null }; // Clear previous errors
    
    case DELETE_ALLOWANCE_SUCCESS:
      return { ...state, loading: false, success:true, deleteResponse: action.payload, error: null };
    
    case DELETE_ALLOWANCE_FAILURE:
      return { ...state, loading: false, success:false, error: action.payload };
      

    default:
      return state;
  }
};

export default payrollSetupAllowanceReducer;
